
 /**
  * Utility class to create a step in a new installation
  * @author Alizée Grand
  * @version 1.0
  * @creation 09/05/2022
  * @last_update 09/05/2022
  **/
export class ProcessStep {

    // Step title
    private _title: string;
    // Step component
    private _component : JSX.Element;

    /**
     * Constructor of the class
     * @param title (string) - step title
     * @param component (JSX.Element) - step component
     */
    constructor(title: string, component: JSX.Element) {
        this._title = title;
        this._component = component;
    }

    // Getters & setters

    get title(): string {
        return this._title;
    }

    set title(value: string) {
        this._title = value;
    }

    get component(): JSX.Element {
        return this._component;
    }

    set component(value: JSX.Element) {
        this._component = value;
    }
}
